<div class="errorView">
  <h4>Oops..!</h4>
  <p>Something went wrong</p>
</div>
